import React, { Component } from 'react'
import Converter from './Converter'
import Crate from 'crate-core'
import styles from './NewDocument.module.css'
const store = require('store')

export default class NewDocument extends Component {
  constructor(props) {
    super(props)
    this.documentId = this.props.match.params.documentId
    const defaultConfig = this.getConfig()
    this.crate = new Crate(defaultConfig)
    window.crate = this.crate
  }
  getConfig() {
    const configuration = store.get('config')

    const defaultConfig = {
      signalingOptions: {
        address: configuration.signalingServer
      },
      storageServer: configuration.storageServer,
      stun: configuration.stunTurn, // default google ones if xirsys not
      ICEsURL: configuration.ICEsURL,
      containerID: 'content-default',
      display: true,
      PingPeriod: 100000,
      AntiEntropyPeriod: 100000,
      documentActivityTimeout: 120000
    }
    return defaultConfig
  }
  componentDidMount() {
    this.initCrate()
  }

  initCrate() {
    this.crate.createNewDocument(this.documentId)
  }

  render() {
    return <div id="content-default" className={styles.document} />
  }
}
